module.exports = __webpack_public_path__ + "static/media/vial.8546c6ec.png";